import { render, staticRenderFns } from "./courseMaterialsPartner.vue?vue&type=template&id=74002867&scoped=true"
import script from "./courseMaterialsPartner.vue?vue&type=script&lang=js"
export * from "./courseMaterialsPartner.vue?vue&type=script&lang=js"
import style0 from "./courseMaterialsPartner.vue?vue&type=style&index=0&id=74002867&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74002867",
  null
  
)

export default component.exports